import { useEffect } from "react";

export function useCustomerPortalGuard(
  isCustomerPortal: boolean,
  customerKeys: string[],
  customerListOpts: Array<{ key: string; name: string }>,
  setCustomerKeys: (keys: string[]) => void,
  activePageRef: React.MutableRefObject<string>,
  setActivePage: (page: any) => void
) {
  useEffect(() => {
    if (!isCustomerPortal) return;

    if (activePageRef.current !== "home" && activePageRef.current !== "rapporter") {
      setActivePage("home");
      activePageRef.current = "home";
    }
  }, [isCustomerPortal, activePageRef, setActivePage]);

  useEffect(() => {
    if (!isCustomerPortal) return;
    if (!Array.isArray(customerKeys) || customerKeys.length === 0) return;
    if (!Array.isArray(customerListOpts) || customerListOpts.length === 0) return;

    const byName = new Map(customerListOpts.map(o => [o.name.toLowerCase(), o.key]));
    const idSet = new Set(customerListOpts.map(o => o.key));

    const normalized = customerKeys.map((k) => {
      const kk = String(k).trim();
      if (idSet.has(kk)) return kk;
      const asId = byName.get(kk.toLowerCase());
      return asId ?? kk;
    });

    const changed =
      normalized.length !== customerKeys.length ||
      normalized.some((v, i) => v !== customerKeys[i]);

    if (changed) setCustomerKeys(normalized);
  }, [isCustomerPortal, customerKeys, customerListOpts, setCustomerKeys]);
}
